import { AnalyticsEvent, SendAnalyticsEvent } from 'shared/entities/analytics';

import {
  clearChannelAfterOnboardingPending,
  clearScenarioAfterOnboardingPending
} from './afterOnboardingEvents';

export const sendChannelCreationOnOnboarding = (
  sendEvent: SendAnalyticsEvent
): void => {
  sendEvent(AnalyticsEvent.channelCreationOnOnboarding);
  clearChannelAfterOnboardingPending();
};

export const sendScenarioCreateOnOnboarding = (
  sendEvent: SendAnalyticsEvent
): void => {
  sendEvent(AnalyticsEvent.scenarioCreationOnOnboarding);
  clearScenarioAfterOnboardingPending();
};

export const sendScenarioWithTemplateOnOnboarding = (
  sendEvent: SendAnalyticsEvent
): void => {
  sendEvent(AnalyticsEvent.scenarioWithTemplateCreationOnOnboarding);
  clearScenarioAfterOnboardingPending();
};
